// src/axios.js
import Axios from 'axios';

const axiosInstance = Axios.create({
    baseURL: 'YOUR_BASE_URL' // if you have a base URL, you can set it here
});

export default axiosInstance;
